export default __webpack_public_path__ + "static/media/$1.e19c7647.png";